import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ErrorHandlingDesign = ({ errorMessage }) => {
  return (
    <>
      <section className="min-h-vh-50">
        <Container className="h-100">
          <Row className="align-items-center h-50">
            <Col>
              <div className="no-property-found align-items-center">
                <FontAwesomeIcon icon={faExclamationCircle} />
                <h5>{errorMessage}</h5>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
